import {
  BannerData,
  ButtonActionType,
  ComponentInstance,
  VariantName
} from '../types';

export const FE_BANNER_IDS = {
  KYC_PENDING: 'fe-kyc-pending',
  KYC_VERIFICATION_PENDING: 'fe-kyc-verification-pending',
  KYC_VERIFICATION_SUBMITTED: 'fe-kyc-verification-submitted'
} as const;

export const KYC_PENDING_BANNER: ComponentInstance<BannerData> = {
  id: FE_BANNER_IDS.KYC_PENDING,
  name: 'kyc_pending_banner',
  variant: VariantName.WARNING,
  is_dismissible: false,
  is_one_time: false,
  data: {
    title: 'Action Required: KYC Update🚨!',
    description:
      'As per revised RBI guidelines, please update your KYC details at the earliest to ensure uninterrupted service. For assistance, please contact your Account Manager.'
  }
};

export const KYC_VERIFICATION_PENDING_BANNER: ComponentInstance<BannerData> = {
  id: FE_BANNER_IDS.KYC_VERIFICATION_PENDING,
  name: 'kyc_verification_pending_banner',
  variant: VariantName.WARNING,
  is_dismissible: false,
  is_one_time: false,
  data: {
    title: 'Add KYC Info',
    description: 'Add KYC Details to activate created groups',
    button: {
      text: 'Add KYC Info',
      action: {
        type: ButtonActionType.CUSTOM,
        target: 'submit-kyc-modal'
      }
    }
  }
};

export const KYC_VERIFICATION_SUBMITTED_BANNER: ComponentInstance<BannerData> =
  {
    id: FE_BANNER_IDS.KYC_VERIFICATION_SUBMITTED,
    name: 'kyc_verification_submitted_banner',
    variant: VariantName.WARNING,
    is_dismissible: false,
    is_one_time: false,
    data: {
      title: 'Verification Pending',
      description: 'We will notify you once the verification is completed.'
    }
  };
